export const blogData = [
  {
    id: "strategies-for-healthcare-digital-marketing-success",
    title: "Digital Marketing Strategies for Healthcare Growth | MediaCook",
    thumbUrl: "images/banner_img.webp",
    date: "October 15",
    year: "2024",
    btnText: "Learn More",
    href: "/blog/strategies-for-healthcare-digital-marketing-success",
    socialShare: true,
    description:
      "Explore top healthcare digital marketing strategies to increase visibility, engage patients, and improve your practice’s success with SEO, PPC, and more.",
  },
  {
    id: "medical-practice-with-effective-seo",
    title: "Effective Healthcare SEO for Medical Professionals | MediaCook",
    thumbUrl: "images/blog/blog2.png",
    date: "January 16",
    year: "2025",
    btnText: "Learn More",
    href: "/blog/medical-practice-with-effective-seo",
    socialShare: true,
    description:
      "Boost your medical practice's online visibility with healthcare SEO. Learn essential strategies to attract patients and rank higher on Google.",
  },
  {
    id: "boost-your-healthcare-business-with-sem",
    title: "Boost Your Healthcare Business with SEM in 2025 | MediaCook",
    thumbUrl: "images/blog/blog3.png",
    date: "January 21",
    year: "2025",
    btnText: "Learn More",
    href: "/blog/boost-your-healthcare-business-with-sem",
    socialShare: true,
    description:
      "Discover how SEM can boost your healthcare business in 2025. Learn strategies to enhance visibility, attract patients, and achieve measurable growth online.",
  },
  {
    id: "human-metapneumovirus-and-its-clinical-impact",
    title: "Emerging Respiratory Virus: HMPV Symptoms & Prevention | MediaCook",
    thumbUrl: "images/blog/blog4.webp",
    date: "February 26",
    year: "2025",
    btnText: "Learn More",
    href: "/blog/human-metapneumovirus-and-its-clinical-impact",
    socialShare: true,
    description:
      "Learn about HMPV, its symptoms, causes, and prevention. Know the risks, diagnosis, and treatment to stay safe from this respiratory virus.",
  },
];
